var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "v-suggestions" }, [
    _c(
      "input",
      _vm._b(
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.query,
              expression: "query",
            },
          ],
          staticClass: "form-control",
          class: _vm.extendedOptions.inputClass,
          attrs: {
            type: "text",
            id: _vm.id,
            placeholder: _vm.extendedOptions.placeholder,
            role: "combobox",
            "aria-autocomplete": "both",
            "aria-owns": "id + '_results'",
            "aaaaria-haspopup": _vm.showItems,
            "aria-expanded": _vm.showItems,
            "aria-describedby": _vm.id + "_aria-descr",
          },
          domProps: { value: _vm.query },
          on: {
            keydown: _vm.onKeyDown,
            blur: _vm.hideItems,
            focus: _vm.showResults,
            input: function ($event) {
              if ($event.target.composing) return
              _vm.query = $event.target.value
            },
          },
        },
        "input",
        _vm.$attrs,
        false
      )
    ),
    _vm._v(" "),
    _vm.showItems
      ? _c(
          "ul",
          {
            staticClass: "typeahead dropdown-menu",
            attrs: { role: "listbox", id: _vm.id + "_results" },
          },
          _vm._l(_vm.items, function (item, index) {
            return _c(
              "li",
              {
                key: index,
                class: { active: index === _vm.activeItemIndex },
                attrs: { role: "presentation" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.selectItem(index)
                  },
                  mouseover: function ($event) {
                    return _vm.highlightItem(index)
                  },
                },
              },
              [
                _vm._t(
                  "item",
                  function () {
                    return [
                      _c(
                        "a",
                        { attrs: { role: "option", href: "#", title: item } },
                        [_vm._v(_vm._s(item))]
                      ),
                    ]
                  },
                  { item: item }
                ),
              ],
              2
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "sr-only", attrs: { id: _vm.id + "_aria-descr" } },
      [
        _vm.minLength > 1
          ? _c("span", [
              _vm._v("Wpisz co najmniej " + _vm._s(_vm.minLength) + " znaków"),
            ])
          : _vm._e(),
        _vm._v(
          "\n      Po rozwinięciu użyj strzałek góra dół, aby zaznaczyć opcję\n      Użyj klawisza enter, aby wybrać\n    "
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "sr-only", attrs: { "aria-live": "assertive" } }, [
      _vm._v("\n      " + _vm._s(_vm.ariaResults) + "\n    "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }